import { useEffect } from 'react'

import { EVENT_NAME_KEY_DOWN } from '../constants/event'
import { isEventKeyEnter, isEventKeyEscape } from '../utils/events'

export function useKeyboard(onEnter, onEscape) {
  useEffect(() => {
    function handleKeyDown(event) {
      if (isEventKeyEscape(event) && onEscape) {
        onEscape()
      } else if (isEventKeyEnter(event) && onEnter) {
        onEnter()
      }
    }

    window.addEventListener(EVENT_NAME_KEY_DOWN, handleKeyDown)

    return function cleanup() {
      window.removeEventListener(EVENT_NAME_KEY_DOWN, handleKeyDown)
    }
  }, [onEnter, onEscape])
}
